import { useSelector } from "react-redux";

/**
 * Pipeline et SAV B2B : réservés aux admins pro (les devs passent aussi).
 * Remplace l'alpha nominative `admin_user.alpha_features` depuis la sortie
 * du mode alpha le 29/10/2026 — cf. PrivateRoute, rôle « pro ».
 */
const useAdminPro = () => {
  const userRoles = useSelector(
    (s) => (s.common && s.common.user && s.common.user.data && s.common.user.data.roles) || []
  );
  return userRoles.includes("ROLE_ADMIN_PRO") || userRoles.includes("ROLE_DEV");
};

export default useAdminPro;
